import Layout from './Layout';
import BlogList from './BlogList';
import useDocumentTitle from '../hooks/useDocumentTitle';

function Writings() {
  useDocumentTitle('Writings');
  return (
    <Layout>
      <BlogList />
    </Layout>
  );
}

export default Writings;
